import { Component, OnInit } from '@angular/core';
import {
  AlertController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { PlainScorecard, PlayerRoundScores } from 'src/data/handicap-history';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { Router } from '@angular/router';
import { DeleteAccountModalComponent } from './delete-account-modal/delete-account-modal.component';

@Component({
  selector: 'app-account-option',
  templateUrl: './account-option.page.html',
  styleUrls: ['./account-option.page.scss'],
})
export class AccountOptionPage implements OnInit {
  public title: string;
  public descriptionText: string;
  public headerName: string;
  public scorecard: PlainScorecard;

  myTime: any = moment();
  teeTime: Date = new Date(); //string; //Date = new Date();
  prevTeeTime: Date; // = new Date();
  myTDate: string; //Date;// = new Date();
  prs: PlayerRoundScores;
  prevTdate: string;

  accountDeletionType: string = 'deactivate';

  appAttribute: any;
  accountDeactivateAtt: any;
  accountDeleteAtt: any;
  accountDeleteSuccessMessage: any = '';

  constructor(
    public nav: NavController,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private router: Router,
    private toastCtl: ToastController,
    private platform: Platform,
    private mg2uUtil: mygolfUtils,
    private alertCtrl: AlertController,
    private flightService: ClubFlightService
  ) {
    this.title = this.navParams.get('title');
    this.descriptionText = this.navParams.get('description');
    this.headerName = this.navParams.get('headerName');
    this.scorecard = this.navParams.get('scorecard');
    this.appAttribute = this.mg2uUtil.getAppAttribute();

    this.teeTime = this.myTime;

    this.prevTeeTime = this.teeTime;
    this.prevTdate = this.myTDate;

    if (this.appAttribute)
      this.appAttribute
        .filter(att => {
          return att.page === 'accountOptions';
        })
        .map(att => {
          console.log('7777777777', att);

          if (att && att.deactivate) this.accountDeactivateAtt = att.deactivate;
          console.log('this.accountDeactivateAtt: ', this.accountDeactivateAtt);
          if (att && att.delete) this.accountDeleteAtt = att.delete;
          console.log('this.accountDeleteAtt: ', this.accountDeleteAtt);
          if (att && att.processedMessage) this.accountDeleteSuccessMessage = att.processedMessage;
        });
  }
  ngOnInit(): void {}

  close() {
    this.myTDate = this.prevTdate;
    this.teeTime = this.prevTeeTime;
    this.modalCtl.dismiss(null);
  }

  onApplyClick() {
    if (1) return false;
    let valid: boolean = true;
    let currentDate = moment().format('YYYY-MM-DD');
    let currentTime = moment().format('HH:mm');

    let selDate = moment(this.myTDate).format('YYYY-MM-DD');
    let selTime = moment(this.teeTime).format('HH:mm');

    console.log('apply click current date/time:', currentDate, ',', currentTime);
    console.log('apply click selected date/time:', selDate, ',', selTime);

    this.scorecard.playedOn = this.myTDate;

    if (selDate > currentDate) {
      valid = false;
    } else if (selDate == currentDate && selTime > currentTime) {
      valid = false;
    }

    if (!valid) {
      let subTitle = 'Please set tee-off date and time in the past or today';
      MessageDisplayUtil.showErrorToast(subTitle, this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }

    if (this.scorecard.playerRoundScores.length > 0) {
      this.scorecard.playerRoundScores.forEach((prs: PlayerRoundScores) => {
        if (!prs.actualStartTime)
          prs.actualStartTime = moment(this.teeTime, 'HH:mm').format('HH:mm');

        if (!prs.startTime) {
          console.log('valid Time');
          prs.startTime = moment(this.teeTime, 'HH:mm').format('HH:mm');
        } else {
          console.log('else');
          prs.startTime = moment(this.teeTime, 'YYYY-MM-DDTHH:mm:ssZ').format('HH:mm');
        }
      });
    }

    this.modalCtl.dismiss({ scorecard: this.scorecard });
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  onClickCancel() {
    this.modalCtl.dismiss();
    //   this.nav.pop();
  }

  async onClickProceed() {
    let _accountDeletionType = '';
    if (this.accountDeletionType === 'deactivate') _accountDeletionType = 'deactivating';
    else if (this.accountDeletionType === 'delete') _accountDeletionType = 'deleting';
    let _message = 'Do you want to proceed with ' + _accountDeletionType + ' your account?';
    const modal = await this.modalCtl.create({
      component: DeleteAccountModalComponent,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      mode: 'ios',
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.goAccountDeletion();
      }
    });
    //   let alert =await this.alertCtrl.create({
    //       header: 'Confirmation',
    //       message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
    //       buttons: [{
    //           text: 'No'
    //       },{
    //           text: 'Yes',
    //           handler: () => {
    //               this.goAccountDeletion();
    //           }
    //       }]
    //   });
    //   alert.present();
  }

  goAccountDeletion() {
    let _msg = '';
    const self = this;
    this.flightService.userRequestAccountDeletion().subscribe({
      next(result) {
        if (result) {
          _msg =
            'Successfully requested for account deletion. This process might take 6-7 days to process';
        } else {
          _msg = 'There was an error. Please try again after a few moments.';
        }
      },
      error() {
        _msg = 'There was an error. Please try again after a few moments.';
      },
      async complete() {
        const modal = await self.modalCtl.create({
          component: DeleteAccountModalComponent,
          cssClass: self.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            modeFrom: 'confirmDelete',
            msg: _msg,
          },
          mode: 'ios',
        });
        await modal.present().then(() => {
          const height = self.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });

        modal.onDidDismiss().then(data => {
          console.debug('dismiss submit acount deletion request', data);
          setTimeout(() => {
            self.modalCtl.dismiss();
          }, 500);
        });
      },
    });

    //   .subscribe((result)=>{
    //       console.debug("request account deletion : ", result)
    //       if(result) {
    //            _msg = 'Successfully requested for account deletion. This process might take 6-7 days to process';
    //           if(this.accountDeleteAtt && this.accountDeleteAtt.processedMessage) _msg = this.accountDeleteAtt.processedMessage;

    //         //   MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');

    //           this.modalCtl.dismiss({needRefresh: true});
    //       } else {
    //         _msg = 'There was an error. Please try again after a few moments.'
    //         //   MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');
    //       }
    //   },(error)=>{
    //       if(error) {
    //         _msg = 'There was an error. Please try again after a few moments.'
    //         // MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');
    //       }
    //   })
  }
}
